import React from "react";

export const enum TabEnum {
  Home = "/home/",
  Practice = "/practice/",
  Profile = "/profile/",
  Settings = "/settings/",
  TeacherPD = "/courses/268/teacher-pd/",
  MyClass = "/my-class/",
  Dashboard = "/schools/dashboard/",
  TeacherResources = "/teacher-resources/",
  SchoolList = "/schools/all/",
  SchoolGroupList = "/schools/groups/",
  SchoolRenewals = "/schools/renewals/",
  SchoolInsights = "/schools/insights/",
}

export interface TabsContextValue {
  currentTab: TabEnum;
  setCurrentTab: (tab: TabEnum) => void;
}

export const TabsContext = React.createContext<TabsContextValue>(null!);
